import { render, staticRenderFns } from "./ReparingOrderSetup.vue?vue&type=template&id=891bc72c&scoped=true&"
import script from "./ReparingOrderSetup.vue?vue&type=script&lang=js&"
export * from "./ReparingOrderSetup.vue?vue&type=script&lang=js&"
import style0 from "./ReparingOrderSetup.vue?vue&type=style&index=0&id=891bc72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891bc72c",
  null
  
)

export default component.exports